var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component, Prop } from 'vue-property-decorator';
var BillSubTable = (function (_super) {
    __extends(BillSubTable, _super);
    function BillSubTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillSubTable.prototype.mounted = function () {
    };
    BillSubTable.prototype.lookSubDetail = function (row) {
        console.log('lookSubDetail');
        this.$emit("lookSubDetail", row);
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], BillSubTable.prototype, "tableData", void 0);
    __decorate([
        Prop({
            type: Object
        })
    ], BillSubTable.prototype, "row", void 0);
    __decorate([
        Prop({
            type: String,
            default: '200px'
        })
    ], BillSubTable.prototype, "operateLabelWidth", void 0);
    BillSubTable = __decorate([
        Component({
            computed: __assign({}, mapGetters({}))
        })
    ], BillSubTable);
    return BillSubTable;
}(Vue));
export default BillSubTable;
